CSS.insert(`
	ui-window.AlertWindow .message { font-weight: var(--font-weight-bold); font-size: 1.1em; line-height: 140%; margin: 0 0 10px; }
	ui-window.AlertWindow .explaination { color: #000; font-size: 0.8em; font-style: normal; line-height: 130%; overflow-x: hidden; overflow-wrap: anywhere; }
	ui-window.AlertWindow .explaination ul { margin: 0.5em 0 0 1.2em; }

	ui-window.AlertWindow .icon {
		width: 60px;
	}

	ui-window.AlertWindow .icon + .message {
		margin-left: 80px;
		margin-top: -60px;
	}

	ui-window.AlertWindow .icon + .message + .explaination {
		margin-left: 80px;
	}

	ui-window.AlertWindow ul.warning {
		list-style: none;
		padding: 0;
		margin: 0.5em 0 0 20px;
	}

	ui-window.AlertWindow ul.warning > li::before {
		content: '⚠';

		position: absolute;
		top: 0;
		left: -20px;

		font-family: SalonIcon, SalonWidgets; 
		font-size: 14px; 
		font-weight: normal; 
		text-transform: none; 
		text-align: center;
		color: var(--colors-orange);
	}
	ui-window.AlertWindow ul.warning > li {
		position: relative;
		margin: 0;
		padding: 0;
	}
`);
Window.Alert = Class.create();
Window.Alert.prototype = {
  initialize: function (options) {
    this.options = Object.assign({
      message: '',
      explaination: null,
      width: 240,
      button: {},
      onClose: null,
      sound: null,
      render: null
    }, options || {});
    this.options.button = Object.assign({
      title: 'OK',
      color: null,
      icon: null
    }, this.options.button);
    this.window = new Window({
      width: this.options.width + (this.options.icon ? 100 : 0),
      height: 'auto',
      modal: true,
      className: 'AlertWindow',
      onClose: this.destroy.bind(this),
      onShow: () => {
        this.button.focus();
      }
    });
    if (this.options.icon) {
      if (this.options.icon.src) {
        let found = this.options.icon.src.match(/([a-z]+)#(.+)/iu);
        if (found) {
          var icon = new Element('img', {
            'class': 'icon'
          });
          icon.src = `../../../assets/icons/${found[1]}/icons/${found[2]}.svg`;
          this.window.contents.appendChild(icon);
        }
      }
    }
    this.message = new Element('div', {
      'class': 'message'
    }).update(this.options.message);
    this.window.contents.appendChild(this.message);
    if (this.options.explaination) {
      var explaination = new Element('div', {
        'class': 'explaination'
      }).update(this.options.explaination);
      this.window.contents.appendChild(explaination);
    }
    if (this.options.render) {
      this.options.render(this.options.explaination ? explaination : this.window.contents);
    }
    this.button = new Widgets.Button(this.window.navigation, {
      title: this.options.button.title,
      color: this.options.button.color,
      icon: this.options.button.icon,
      onClick: this.onClick.bind(this)
    });
    if (this.options.sound) {
      Application.playSound(this.options.sound);
    }
    this.window.show();
  },
  destroy: function () {
    if (this.options.onClose) {
      this.options.onClose();
    }
  },
  onClick: function () {
    this.window.close();
  }
};
//# sourceMappingURL=alert.js.map
